import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";

import { Question } from "../../components/svg/svgImageList";
import useThemeService from "../../services/theme-service/ThemeService";
import {
  TranslationContext,
  translationService,
} from "../../services/translation/TranslationService";
import { featureFlagsStorage } from "../../services/feature-flags/FeatureFlagsStorage";
import "./composition.scss";
import { Dialog, DialogOkButton } from "../dialog/Dialog";
import { Flags } from "../../generated/FeatureFlags";

interface WarningBeforeActionProps {
  titleKey: string;
  titleContext?: TranslationContext;
  subtitleKey?: string;
  subtitleContext?: TranslationContext;
  buttonOk: DialogOkButton;
  additionalButton?: DialogOkButton;
  onHide?: () => void;
  children?: ReactNode;
  isVisible: boolean;
  toggleModal: () => void;
  optionalWarningKey?: string;
  optionalWarningContext?: TranslationContext;
  canUserRestoreDeletedEntity?: boolean;
  hideCancelButton?: boolean;
  cancelbuttonAction?: () => void;
}

export default function WarningBeforeAction(props: WarningBeforeActionProps) {
  const { themeClass } = useThemeService();

  const history = useHistory();

  const iconQuestion = {
    svg: Question,
    width: 30,
    height: 30,
    className: themeClass(["icon-question"]),
  };

  if (!props.isVisible) return null;

  return (
    <Dialog
      isVisible={props.isVisible}
      onHide={() => {
        props.toggleModal();
        props.onHide?.();
      }}
      iconTitle={iconQuestion}
      titleKey={props.titleKey}
      titleContext={props.titleContext}
      subTextKey={props.subtitleKey}
      subtitleContext={props.subtitleContext}
      buttonOk={props.buttonOk}
      additionalButton={props.additionalButton}
      buttonCancel={
        props.hideCancelButton
          ? undefined
          : {
              id: "cancel",
              textKey: "general.cancel",
              action: () => {
                props.toggleModal();
                props.cancelbuttonAction?.();
              },
            }
      }
    >
      {props.children}
      {props.optionalWarningKey && (
        <p className="subtext-dialog-light">
          {translationService.translate(props.optionalWarningKey, props.optionalWarningContext)}
        </p>
      )}
      {featureFlagsStorage.isFeatureEnabled(Flags.Show_Page_Deleted_Data) &&
        props.canUserRestoreDeletedEntity && (
          <p className="subtext-link-to-deleted-data">
            {translationService.translate("general.deleted-data.link-to-page-part1")}
            <u
              className="link"
              onClick={() => history.push({ pathname: "/settings/deleted-data" })}
            >
              {translationService.translate("general.deleted-data.link-to-page-part2")}
            </u>
            {translationService.translate("general.deleted-data.link-to-page-part3")}
          </p>
        )}
    </Dialog>
  );
}
